import { Talent } from "../../Classes";

const tier6 = [
  null,
  null,
  new Talent(
    "One-Handed Weapon Specialization",
    "inv_sword_20",
    ["Increases the damage you deal with One-Handed Weapons by ", "%."],
    5,
    [[2, 4, 6, 8, 10]],
  ),
  null,
];

export default tier6;
